import {GET_USER_SUBSCRIPTIONS} from "../../actions/type";

const initialState=[];

export default function userSubscriptions(state=initialState,action){
    switch(action.type){
        case GET_USER_SUBSCRIPTIONS:
            return action.payload;
        default:
            return state
    }
}